// Wires up snippets/notify-me-form.liquid, rendered on the product page in
// place of the old ZooomyBackinStock / spurit_isr widgets. Uses a plain
// button + click handler (not <form>/submit) since it's nested inside the
// page's existing Add to Cart form, and HTML doesn't allow nested forms.
const NOTIFY_WORKER_URL = 'https://nafarimoda-shopify-tool.black-glitter-7f0a.workers.dev/signup';
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function getProductData() {
  const script = document.querySelector('script[id^="ProductJson-"]');
  if (!script) return null;
  try {
    return JSON.parse(script.textContent);
  } catch {
    return null;
  }
}

function findMatchingVariant(product, optionValues) {
  return product.variants.find((variant) =>
    optionValues.every((value, i) => value == null || variant[`option${i + 1}`] === value)
  );
}

function updateNotifyWidget(variant) {
  const container = document.querySelector('[data-notify-me]');
  if (!container) return;

  if (variant && !variant.available) {
    container.hidden = false;
    container.dataset.variantId = variant.id;
    const form = container.querySelector('[data-notify-me-form]');
    if (form) form.hidden = false;
    const status = container.querySelector('[data-notify-me-status]');
    if (status) status.hidden = true;
  } else {
    container.hidden = true;
  }
}

// This theme uses jQuery-style <select class="single-option-selector"> dropdowns
// (data-index="option1"/"option2"/"option3") rather than a modern variant:change event.
document.addEventListener('change', (event) => {
  if (!event.target.matches('.single-option-selector')) return;

  const product = getProductData();
  if (!product) return;

  const optionValues = [];
  document.querySelectorAll('.single-option-selector').forEach((select) => {
    const index = parseInt(select.dataset.index.replace('option', ''), 10) - 1;
    optionValues[index] = select.value;
  });

  updateNotifyWidget(findMatchingVariant(product, optionValues));
});

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-notify-me-submit]');
  if (!button) return;

  event.preventDefault();

  const container = button.closest('[data-notify-me]');
  const emailInput = container?.querySelector('[data-notify-me-email]');
  const email = emailInput ? emailInput.value.trim() : '';
  const variantId = container?.dataset.variantId;
  const statusEl = container?.querySelector('[data-notify-me-status]');

  if (statusEl) {
    statusEl.textContent = '';
    statusEl.hidden = true;
    statusEl.classList.remove('notify-me__status--error');
  }

  if (!EMAIL_RE.test(email)) {
    if (statusEl) {
      statusEl.textContent = 'Enter a valid email address.';
      statusEl.hidden = false;
      statusEl.classList.add('notify-me__status--error');
    }
    return;
  }

  if (!variantId) return;

  button.disabled = true;

  try {
    const response = await fetch(NOTIFY_WORKER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ variantId, email }),
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      if (statusEl) {
        statusEl.textContent = data.error || 'Something went wrong. Please try again.';
        statusEl.hidden = false;
        statusEl.classList.add('notify-me__status--error');
      }
      return;
    }

    const formEl = container.querySelector('[data-notify-me-form]');
    if (formEl) formEl.hidden = true;
    if (statusEl) {
      statusEl.textContent = "You're on the list — we'll email you when it's back.";
      statusEl.hidden = false;
      statusEl.classList.remove('notify-me__status--error');
    }
  } catch {
    if (statusEl) {
      statusEl.textContent = 'Something went wrong. Please try again.';
      statusEl.hidden = false;
      statusEl.classList.add('notify-me__status--error');
    }
  } finally {
    button.disabled = false;
  }
});
